function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { useMemo, useRef } from "react";
import { CAROUSEL_PROPS } from "segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/consts";
import PrevCarouselArrow from "./carousle-arrows/prev-carousel-arrow";
import NextCarouselArrow from "./carousle-arrows/next-carousel-arrow";
import { StyledCarouselTagsComponent } from "./carousel-tags-component.scss";
const CarouselTagsComponent = ({ cards = [], autoPlay, isInView, tagsCarouselProps, cardHeight })=>{
    const slider = useRef(null);
    const isAutoPlay = useMemo(()=>isInView && !!autoPlay.enable, [
        isInView,
        autoPlay.enable
    ]);
    const carouselProps = {
        items: cards,
        defaultIndex: 0,
        autoplay: isAutoPlay,
        autoplaySpeed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.autoplaySpeed,
        speed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.speed,
        prevArrow: /*#__PURE__*/ _jsx(PrevCarouselArrow, {
            pause: ()=>{
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        }),
        nextArrow: /*#__PURE__*/ _jsx(NextCarouselArrow, {
            pause: ()=>{
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        })
    };
    return /*#__PURE__*/ _jsx(StyledCarouselTagsComponent, {
        onMouseLeave: ()=>{
            var _slider_current;
            return isAutoPlay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.play());
        },
        cardHeight: cardHeight,
        className: "carousel-tags-component",
        children: /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, CAROUSEL_PROPS, carouselProps, tagsCarouselProps), {
            ref: slider
        }))
    });
};
export default CarouselTagsComponent;
